import { render, staticRenderFns } from "./PostbackCallsBreakdown.vue?vue&type=template&id=4e088535&scoped=true"
import script from "./PostbackCallsBreakdown.vue?vue&type=script&lang=js"
export * from "./PostbackCallsBreakdown.vue?vue&type=script&lang=js"
import style0 from "./PostbackCallsBreakdown.vue?vue&type=style&index=0&id=4e088535&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e088535",
  null
  
)

export default component.exports